// extracted by mini-css-extract-plugin
export default {"root":"IconCalender_root__Fp-pD"};